export default __webpack_public_path__ + "static/media/themebel_cube.e5b4c964.svg";